import { render, staticRenderFns } from "./sellTouristList.vue?vue&type=template&id=ed903b22&scoped=true"
import script from "./sellTouristList.vue?vue&type=script&lang=js"
export * from "./sellTouristList.vue?vue&type=script&lang=js"
import style0 from "./sellTouristList.vue?vue&type=style&index=0&id=ed903b22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed903b22",
  null
  
)

export default component.exports